(function (global, factory) {
    "use strict";
    if ("function" === typeof define && define.amd) {
        // If supports for AMD is available return the value to the AMD Loader
        // // and to the global (window) object in case any JS module.
        define([], function () {
            return (global.performanceEventsQueue = factory(global));
        });
    } else if ("object" === typeof exports) {
        // If supports for Common JS is available export the module
        // // and pass is value to the global (window) object in case non Common JS code
        // // is expected to work
        module.exports = (global.performanceEventsQueue = factory(global));
    } else {
        // If not support for AMD or Common JS is available register the module in the global scope.
        global.performanceEventsQueue = factory(global);
    }
})("undefined" !== typeof window ? window : {}, function (root) {
    /*
     * This queue is going to hold all the urls that needs GA values before GA has been downloaded by the browser
     */
    var eventsQueue = [];
    /*
     * This module exposes a function for queuing to the eventsQueue property
     */
    var enqueueEvent = function (url) {
        if (eventsQueue) {
            eventsQueue.push(url);
        }
    };
    /*
     * This function takes the values from GA and fires the logging of all the queued events considering these values as part of the request
     */
    function fireEvents() {
        if (eventsQueue.length > 0 && typeof (ga) === "function") {
            ga(function() {
                var urlWithGaValues = analyticsHelper.addAnalyticsUrlParameters("");
                for (var i = eventsQueue.length - 1; i >= 0; i--) {
                    var url = eventsQueue.pop();
                    var xhr = new XMLHttpRequest();
                    var indexOfQueryString = url.indexOf("?");
                    if (indexOfQueryString === -1) {
                        url = url + urlWithGaValues;
                    } else {
                        url = url.substring(0, indexOfQueryString) +
                            urlWithGaValues +
                            url.substring(indexOfQueryString, url.length);
                    }
                    // the 3rd param sets async = true
                    xhr.open("POST", url, true);
                    xhr.send();
                }
                delete eventsQueue;
            });
        }
    };

    window.onload = fireEvents;

    return {
        enqueueEvent: enqueueEvent
    }
});